import { render, staticRenderFns } from "./PortfolioPage.vue?vue&type=template&id=29b609c5&scoped=true"
import script from "./PortfolioPage.vue?vue&type=script&lang=ts"
export * from "./PortfolioPage.vue?vue&type=script&lang=ts"
import style0 from "./PortfolioPage.vue?vue&type=style&index=0&id=29b609c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b609c5",
  null
  
)

export default component.exports